import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
	standalone: true,
	imports: [CommonModule],
	template: `
		<div class="modal-header">
			<h5 class="modal-title">Sedentäre und sedimentäre Moorsubstrate</h5>
			<button type="button" class="btn-close" aria-label="Schließen" (click)="activeModal.dismiss()"></button>
		</div>
		<div class="modal-body">
			<h6>Sedentäre Moorsubstrate = Torfsubstrate</h6>
			<table class="table table-sm table-bordered substrate-table">
				<thead>
					<tr>
						<th rowspan="2">org. Anteil</th>
						<th colspan="4">karbonatischer Anteil</th>
					</tr>
					<tr>
						<th>&lt;5 %</th>
						<th>5–10 %</th>
						<th>&gt;10–90 %</th>
						<th>&gt;90 %</th>
					</tr>
				</thead>
				<tbody>
					<tr>
						<td>&gt;15–30 %</td>
						<td>Antorf <strong>ah</strong></td>
						<td>Ankalkantorf <strong>akah</strong></td>
						<td>Kalkantorf <strong>kah</strong></td>
						<td rowspan="4" class="vertical-cell">Reinkalk <strong>k</strong></td>
					</tr>
					<tr>
						<td>&gt;30–70 %</td>
						<td>Halbtorf <strong>ih</strong></td>
						<td>Ankalkhalbtorf <strong>akih</strong></td>
						<td>Kalkhalbtorf <strong>kih</strong></td>
					</tr>
					<tr>
						<td>&gt;70–90 %</td>
						<td>Volltorf <strong>vh</strong></td>
						<td>Ankalkvollttorf <strong>akvh</strong></td>
						<td>Kalkvolltorf <strong>kvh</strong></td>
					</tr>
					<tr>
						<td>&gt;90 %</td>
						<td>Reintorf <strong>ph</strong></td>
						<td>Ankalkreintorf <strong>akph</strong></td>
						<td>–</td>
					</tr>
				</tbody>
			</table>

			<h6 class="mt-3">Sedimentäre Moorsubstrate = Modd-Substrate</h6>
			<table class="table table-sm table-bordered substrate-table">
				<thead>
					<tr>
						<th rowspan="2">org. Anteil</th>
						<th colspan="5">karbonatischer Anteil</th>
					</tr>
					<tr>
						<th>&lt;5 %</th>
						<th>5–30 %</th>
						<th>&gt;30–70 %</th>
						<th>&gt;70–90 %</th>
						<th>&gt;90 %</th>
					</tr>
				</thead>
				<tbody>
					<tr>
						<td>&gt;5–15 %</td>
						<td>Fledd <strong>d</strong></td>
						<td>Ankalkfledd <strong>akd</strong></td>
						<td>Kalkfledd <strong>kd</strong></td>
						<td></td>
						<td></td>
					</tr>
					<tr>
						<td>&gt;15–30 %</td>
						<td>Quebb <strong>q</strong></td>
						<td>Ankalkquebb <strong>akq</strong></td>
						<td>Kalkquebb <strong>kq</strong></td>
						<td rowspan="2">Moddkalk <strong>mk</strong></td>
						<td rowspan="2">Reinkalk <strong>k</strong></td>
					</tr>
					<tr>
						<td>&gt;30–70 %</td>
						<td>Halbmodd <strong>im</strong></td>
						<td>Ankalkhalbmodd <strong>akim</strong></td>
						<td>Kalkhalbmodd <strong>kim</strong></td>
					</tr>
					<tr>
						<td>&gt;70 %</td>
						<td>Vollmodd <strong>vm</strong></td>
						<td>Ankalkvollmodd <strong>akvm</strong></td>
						<td>–</td>
						<td></td>
						<td></td>
					</tr>
				</tbody>
			</table>

			<p class="text-muted small mt-2 mb-0">Quelle: SEA TeilA, Darst. A 2-1, S. 88</p>
		</div>
	`,
	styles: [`
		.substrate-table {
			font-size: 0.85rem;
		}
		.substrate-table th {
			text-align: center;
			vertical-align: middle;
			background: #f8f9fa;
		}
		.substrate-table td {
			white-space: nowrap;
		}
		.substrate-table td:first-child {
			text-align: right;
			font-weight: 500;
		}
		.vertical-cell {
			vertical-align: middle;
			text-align: center;
		}
		h6 {
			font-weight: 600;
		}
	`]
})
export class MoorsubstratInfoModalComponent {
	constructor(public activeModal: NgbActiveModal) {}
}
